import module from './shared.module';

import './services/shared-service.index';
import './services/current-user.service';
import './services/user-account.service';
import './services/app.service';
import './services/login.service';

import './components/friend-list/friend-list.index';
import './components/gift-list/gift-list.index';
import './components/bought-list/bought-list.index';
import './components/suggested-list/suggested-list.index';

export default module.name;
